<template>
    <div class="app">
      <Header></Header>
        <div class="mid">
            <div class="ed-header">
                <div class="ed-filter box-sizing">
                    <span>时间：</span>
                    <span>
                        <el-date-picker
                                v-model="timeGroup"
                                type="daterange"
                                unlink-panels
                                value-format="timestamp"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :editable="false"
                                :picker-options="pickerOptions"
                                :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </span>
                    <span class="ml-10"><el-button type="primary" @click="searchUrl">搜索</el-button></span>
                </div>
                <div class="ed-link box-sizing">
                    <span>短网址：</span>
                    <a class="link1" href="http://ii46.cn/3RxSsq" target="_blank">http://ii46.cn/3RxSsq</a>
                    <span>原网址：</span>
                    <a class="link2" href="https://ttdwz.cc/" target="_blank">https://ttdwz.cc/</a>
                    <span>备注：天天短网址</span>
                </div>
            </div>
            <div class="access-data">
                <div class="ad-item">
                    <div class="l-icon bg-blue"><i class="iconfont iconshuju1"></i></div>
                    <div class="m-data">
                        <div class="m-text">总访问量（PV）</div>
                        <div class="m-num ellipsis">42897</div>
                    </div>
                </div>
                <div class="ad-item middle">
                    <div class="l-icon bg-green"><i class="iconfont iconuvip"></i></div>
                    <div class="m-data">
                        <div class="m-text">总访独立用户数（UV）</div>
                        <div class="m-num ellipsis">21021</div>
                    </div>
                </div>
                <div class="ad-item">
                    <div class="l-icon bg-red"><i class="iconfont iconshebei3"></i></div>
                    <div class="m-data">
                        <div class="m-text">总IP数</div>
                        <div class="m-num ellipsis">20049</div>
                    </div>
                </div>
            </div>
            <div class="chart-box1" ref="lineChart"></div>
            <div class="chart-box1">
                <div class="pie-chart" ref="pieChart"></div>
                <div class="bar-chart">
                    <div class="title">客户端TOP5</div>
                    <div class="subtext">数据来源：天天短网址</div>
                    <div class="progress">
                        <div class="lab">Android</div>
                        <el-progress :text-inside="true" :stroke-width="25" :percentage="22.74" :color="'#049dff'"></el-progress>
                        <div class="lab">iPhone</div>
                        <el-progress :text-inside="true" :stroke-width="25" :percentage="22.43" :color="'#fdba04'"></el-progress>
                        <div class="lab">PC</div>
                        <el-progress :text-inside="true" :stroke-width="25" :percentage="19.87" :color="'#1abc9c'"></el-progress>
                        <div class="lab">未知</div>
                        <el-progress :text-inside="true" :stroke-width="25" :percentage="17.89" :color="'#ed687c'"></el-progress>
                        <div class="lab">iPad</div>
                        <el-progress :text-inside="true" :stroke-width="25" :percentage="17.08" :color="'#99cc66'"></el-progress>
                    </div>
                </div>
            </div>
            <div class="chart-box1" ref="broChart"></div>
            <div class="chart-box2" ref="mapChart"></div>
            <div class="chart-box2" ref="torChart"></div>
            <div class="record-box">
                <div class="title">高频访问IP名单 TOP 10</div>
                <div class="subtext">数据来源：天天短网址</div>
                <div class="content">
                    <el-table :data="ipRecord" empty-text="暂无数据">
                        <el-table-column prop="ip" label="IP"></el-table-column>
                        <el-table-column prop="visits" label="访问次数"></el-table-column>
                        <el-table-column label="IP归属地">
                            <template slot-scope="scope">{{scope.row.address}}-{{scope.row.isp}}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="record-box">
                <div class="title">访问记录明细</div>
                <div class="subtext">数据来源：天天短网址</div>
                <div class="content">
                    <el-table :data="accessRecord" empty-text="暂无数据">
                        <el-table-column prop="time" label="时间" width="170"></el-table-column>
                        <el-table-column prop="dev" label="设备" width="140"></el-table-column>
                        <el-table-column prop="browser" label="浏览器" width="140"></el-table-column>
                        <el-table-column prop="ip" label="IP" width="140"></el-table-column>
                        <el-table-column prop="source_domain" label="访问来源"></el-table-column>
                        <el-table-column label="IP归属地">
                            <template slot-scope="scope">{{scope.row.area}}-{{scope.row.isp}}</template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagebar">
                    <el-pagination background layout="total, prev, pager, next, jumper" :total="100" @current-change="handleCurrentPage"></el-pagination>
                </div>
            </div>
        </div>
        <div class="footer">Copyright &copy; 2018-2019  版权所有</div>
    </div>
</template>

<script>
    import '../../assets/js/map/js/china';
    import eCharts from 'echarts';
    import Header from "../header";
    export default {
        name: "StatisticsDemo",
      components: {Header},
      data() {
            const mydata = [
                {'name':'北京','value':7123},{'name':'天津','value':4246},{'name':'上海','value':7356},
                {'name':'重庆','value':4876},{'name':'河北','value':3678},{'name':'河南','value':3946},
                {'name':'云南','value':4259},{'name':'辽宁','value':3645},{'name':'黑龙江','value':3246},
                {'name':'湖南','value':3697},{'name':'安徽','value':2547},{'name':'山东','value':1356},
                {'name':'新疆','value':1203},{'name':'江苏','value':4659},{'name':'浙江','value':6241},
                {'name':'江西','value':5423},{'name':'湖北','value':5763},{'name':'广西','value':3561},
                {'name':'甘肃','value':2315},{'name':'山西','value':3612},{'name':'内蒙古','value':2453},
                {'name':'陕西','value':1234},{'name':'吉林','value':2364},{'name':'福建','value':8654},
                {'name':'贵州','value':3245},{'name':'广东','value':6589},{'name':'青海','value':3612},
                {'name':'西藏','value':2786},{'name':'四川','value':3664},{'name':'宁夏','value':2854},
                {'name':'海南','value':1356},{'name':'台湾','value':532},{'name':'香港','value':245},
                {'name':'澳门','value':345}
            ];
            const barData = [
                {naem:'福建',value:8654},{naem:'上海',value:7356},{naem:'北京',value:7123},{naem:'广东',value:6589},
                {naem:'浙江',value:6241},{naem:'湖北',value:5763},{naem:'江西',value:5423},
                {naem:'重庆',value:4876},{naem:'江苏',value:4659},{naem:'云南',value:4259}
            ];
            const yData = ['0福建','1上海','2北京','3广东','4浙江','5湖北', '6江西','7重庆','8江苏','9云南'];
            return {
                isVip: false,
                isGuest: true,
                user_info: {},
                timeGroup: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                chart: {
                    pv: {
                        title: {
                            text: '访问数据',
                            subtext: '数据来源：天天短网址',
                        },
                        tooltip: {
                            trigger: 'axis'
                        },
                        legend: {
                            data:['PV','UV','IP']
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        toolbox: {
                            show : true,
                            feature : {
                                saveAsImage : {show: true}
                            }
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: ['2019-04-01','2019-04-02','2019-04-03','2019-04-04','2019-04-05','2019-04-06','2019-04-07'],
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                            {
                                name:'PV',
                                type:'line',
                                data:['8756','2584','8524','3145','5485','7862','6541'],
                            },
                            {
                                name:'UV',
                                type:'line',
                                data:['2354','535','4553','1354','2536','5324','4365'],
                            },
                            {
                                name:'IP',
                                type:'line',
                                data:['2336','520','4132','1351','2451','5103','4156'],
                            }
                        ]
                    },
                    dev: {
                        title : {
                            text: '客户端统计',
                            subtext: '数据来源：天天短网址',
                            x:''
                        },
                        tooltip : {
                            trigger: 'item',
                            formatter: "{a} <br/>{b} : {c} ({d}%)"
                        },
                        toolbox: {
                            show : true,
                            feature : {
                                saveAsImage : {show: true}
                            }
                        },
                        legend: {
                            orient: 'vertical',
                            bottom: 'bottom',
                            data: ['iPhone','PC','Android','Mac','iPad','未知'],
                        },
                        calculable : true,
                        series : [
                            {
                                name:'客户端',
                                type:'pie',
                                radius : '55%',
                                center: ['50%', '55%'],
                                data:[
                                    {name:'iPhone',value:8643},{name:'PC',value:7658},{name:'Android',value:8762},
                                    {name:'Mac',value:2685},{name:'iPad',value:6582},{name:'未知',value:6893},
                                ],
                                itemStyle: {
                                    emphasis: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    },
                    bro: {
                        title: {
                            text: '访问者浏览器统计',
                            subtext: '数据来源：天天短网址',
                        },
                        color: ['#3398DB'],
                        tooltip : {
                            trigger: 'axis',
                            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis : [
                            {
                                type : 'category',
                                data : ['chrome','Firefox','UCBrowser','QQBrowser','MicroMessenger','MetaSr','Safari','Maxthon','未知'],
                                axisLabel:{
                                    interval:0,
                                },
                            }
                        ],
                        yAxis : [{type : 'value'}],
                        toolbox: {
                            show : true,
                            feature : {
                                saveAsImage : {show: true}
                            }
                        },
                        series : [
                            {
                                name:'访问量',
                                type:'bar',
                                barWidth: '30%',
                                data:[8654,8254,7942,7655,7346,6120,5120,1350,569],
                                itemStyle: {
                                    normal: {
                                        color: function (params) {
                                            var colorList = ['#1997D6', '#06D6A0', '#FED066', '#EF476F', '#0098CB', '#99CC66','#FFCC00','#FF6699'];
                                            return colorList[params.dataIndex];
                                        }
                                    }
                                }
                            }
                        ]
                    },
                    map: {
                        title: {
                            text: '全国地图大数据',
                            subtext: '数据来源：天天短网址',
                        },
                        tooltip: {
                            show: true,
                            formatter: function(params) {
                                return params.name + '：' + params.data['value'];
                            },
                        },
                        toolbox: {
                            show : true,
                            feature : {
                                saveAsImage : {show: true}
                            }
                        },
                        visualMap: {
                            text:['高','低'],
                            realtime: false,
                            calculable: true,
                            max:8654,
                            inRange: {
                                color: ['lightskyblue','yellow', 'orangered']
                            }
                        },
                        grid: {
                            right: 10,
                            width: '20%'
                        },
                        xAxis: {
                            show: false
                        },
                        yAxis: {
                            type: 'category',
                            inverse: true,
                            nameGap: 16,
                            axisLine: {
                                show: false,
                                lineStyle: {
                                    color: '#ddd'
                                }
                            },
                            axisTick: {
                                show: false,
                                lineStyle: {
                                    color: '#ddd'
                                }
                            },
                            axisLabel: {
                                interval: 0,
                                margin: 85,
                                textStyle: {
                                    color: '#455A74',
                                    align: 'left',
                                    fontSize: 14
                                },
                                rich: {
                                    a: {
                                        color: '#fff',
                                        backgroundColor: '#FAAA39',
                                        width: 20,
                                        height: 20,
                                        align: 'center',
                                        borderRadius: 2
                                    },
                                    b: {
                                        color: '#fff',
                                        backgroundColor: '#4197FD',
                                        width: 20,
                                        height: 20,
                                        align: 'center',
                                        borderRadius: 2
                                    }
                                },
                                formatter: function(params) {
                                    let data = [];
                                    if (parseInt(params.slice(0, 1)) < 3) {
                                        data = [
                                            '{a|' + (parseInt(params.slice(0, 1)) + 1) + '}' + '  ' + params.slice(1)
                                        ].join('\n')
                                    } else {
                                        data = [
                                            '{b|' + (parseInt(params.slice(0, 1)) + 1) + '}' + '  ' + params.slice(1)
                                        ].join('\n')
                                    }
                                    return data;
                                }
                            },
                            data: yData
                        },
                        geo: {
                            // roam: true,
                            map: 'china',
                            left: 'left',
                            right: '300',
                            // layoutSize: '80%',
                            label: {
                                emphasis: {
                                    show: false
                                }
                            },
                            itemStyle: {
                                emphasis: {
                                    areaColor: '#fff464'
                                }
                            }
                        },
                        series: [{
                            name: 'mapSer',
                            type: 'map',
                            roam: false,
                            geoIndex: 0,
                            label: {
                                show: false,
                            },
                            data: mydata,
                        }, {
                            name: 'barSer',
                            type: 'bar',
                            roam: false,
                            visualMap: false,
                            zlevel: 2,
                            barMaxWidth: 8,
                            barGap: 0,
                            itemStyle: {
                                normal: {
                                    color: function(params) {
                                        // build a color map as your need.
                                        var colorList = [{
                                            colorStops: [{
                                                offset: 0,
                                                color: '#FFD119' // 0% 处的颜色
                                            }, {
                                                offset: 1000,
                                                color: '#FFAC4C' // 100% 处的颜色
                                            }]
                                        },
                                            {
                                                colorStops: [{
                                                    offset: 0,
                                                    color: '#00C0FA' // 0% 处的颜色
                                                }, {
                                                    offset: 1000,
                                                    color: '#2F95FA' // 100% 处的颜色
                                                }]
                                            }
                                        ];
                                        if (params.dataIndex < 3) {
                                            return colorList[0]
                                        } else {
                                            return colorList[1]
                                        }
                                    },
                                    barBorderRadius: 15
                                }
                            },
                            data: barData,
                        }]
                    },
                    tor: {
                        title: {
                            text: '网络供应商统计',
                            subtext: '数据来源：天天短网址',
                        },
                        tooltip : {
                            trigger: 'axis',
                            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
                                type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis:  {
                            type: 'value'
                        },
                        yAxis: {
                            inverse: true,
                            type: 'category',
                            data: ['电信','联通','移动','鹏博士','长城','广电','其他'],
                        },
                        toolbox: {
                            show : true,
                            feature : {
                                saveAsImage : {show: true}
                            }
                        },
                        series: [
                            {
                                name: '直接访问',
                                type: 'bar',
                                stack: '总量',
                                label: {
                                    normal: {
                                        show: true,
                                        position: 'insideRight'
                                    }
                                },
                                barWidth: '30%',
                                data:[8654,7854,7651,6235,6123,5964,3654],
                                itemStyle: {
                                    normal: {
                                        color: function (params) {
                                            var colorList = ['#1997D6', '#06D6A0', '#FED066', '#EF476F', '#0098CB', '#99CC66','#FFCC00','#FF6699'];
                                            return colorList[params.dataIndex];
                                        }
                                    }
                                }
                            }
                        ]
                    }
                },
                ipRecord: [
                    {
                        "visits": 125,
                        "ip": "117.136.45.197",
                        "isp": "移动数据上网公共出口",
                        "address": "江苏省淮安市"
                    },
                    {
                        "visits": 110,
                        "ip": "106.32.191.52",
                        "isp": "电信",
                        "address": "贵州省遵义市"
                    },
                    {
                        "visits": 91,
                        "ip": "117.136.106.135",
                        "isp": "移动",
                        "address": "河南省"
                    },
                    {
                        "visits": 76,
                        "ip": "117.136.15.222",
                        "isp": "移动数据上网公共出口",
                        "address": "四川省"
                    },
                    {
                        "visits": 73,
                        "ip": "139.205.15.76",
                        "isp": "电信",
                        "address": "四川省德阳市"
                    },
                    {
                        "visits": 65,
                        "ip": "113.201.250.0",
                        "isp": "联通",
                        "address": "陕西省安康市"
                    },
                    {
                        "visits": 65,
                        "ip": "117.136.62.120",
                        "isp": "移动数据上网公共出口",
                        "address": "四川省"
                    },
                    {
                        "visits": 65,
                        "ip": "223.104.24.105",
                        "isp": "移动数据上网公共出口",
                        "address": "贵州省"
                    },
                    {
                        "visits": 65,
                        "ip": "223.104.24.107",
                        "isp": "移动数据上网公共出口",
                        "address": "贵州省"
                    },
                    {
                        "visits": 61,
                        "ip": "58.16.228.91",
                        "isp": "联通",
                        "address": "贵州省贵阳市"
                    }
                ],
                accessRecord: [
                {
                    "time": "2020-02-11 22:01:00",
                    "area": "四川省",
                    "ip": "117.136.64.240",
                    "isp": "移动数据上网公共出口",
                    "browser": "MicroMessenger",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:59",
                    "area": "广东省",
                    "ip": "112.96.66.208",
                    "isp": "联通数据上网公共出口",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:58",
                    "area": "新疆昌吉州",
                    "ip": "223.116.99.79",
                    "isp": "移动",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:57",
                    "area": "重庆市",
                    "ip": "14.108.202.172",
                    "isp": "电信",
                    "browser": "MicroMessenger",
                    "dev": "iPhone",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:55",
                    "area": "贵州省贵阳市",
                    "ip": "106.108.19.174",
                    "isp": "电信",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:52",
                    "area": "广西桂林市",
                    "ip": "116.1.121.136",
                    "isp": "电信",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:49",
                    "area": "新疆乌鲁木齐市",
                    "ip": "49.117.188.151",
                    "isp": "电信",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:48",
                    "area": "亚太地区",
                    "ip": "103.85.144.182",
                    "isp": "",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:47",
                    "area": "河北省石家庄市",
                    "ip": "221.192.181.45",
                    "isp": "联通",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:42",
                    "area": "贵州省",
                    "ip": "223.104.96.105",
                    "isp": "移动",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:41",
                    "area": "四川省遂宁市射洪县",
                    "ip": "125.67.103.106",
                    "isp": "电信",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:38",
                    "area": "云南省丽江市",
                    "ip": "223.104.238.58",
                    "isp": "移动",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:32",
                    "area": "河南省开封市",
                    "ip": "61.158.147.17",
                    "isp": "联通",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:30",
                    "area": "中国",
                    "ip": "111.27.177.94",
                    "isp": "移动",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:28",
                    "area": "四川省",
                    "ip": "117.136.62.149",
                    "isp": "移动数据上网公共出口",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:27",
                    "area": "四川省",
                    "ip": "117.136.64.18",
                    "isp": "移动数据上网公共出口",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:26",
                    "area": "江苏省",
                    "ip": "117.136.67.78",
                    "isp": "移动数据上网公共出口",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:22",
                    "area": "河南省开封市",
                    "ip": "61.158.147.17",
                    "isp": "联通",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:20",
                    "area": "中国",
                    "ip": "117.136.125.171",
                    "isp": "移动",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                },
                {
                    "time": "2020-02-11 22:00:20",
                    "area": "广东省",
                    "ip": "14.25.154.195",
                    "isp": "电信",
                    "browser": "MQQBrowser",
                    "dev": "Android",
                    "source_domain": "直接访问"
                }
            ],
            }
        },
        mounted() {
            const token = this.$storeLocal.get('token');
            const user_info = this.$storeLocal.get('userInfo');
            const times = Date.parse(new Date())/1000;

            if (token !== null && token !== '' && token !== undefined) {
                if (user_info.expire_date > times){
                    this.isVip = true;
                }
                this.isGuest = false;
                this.user_info = user_info;
            }
            eCharts.init(this.$refs.lineChart).setOption(this.chart.pv);
            eCharts.init(this.$refs.pieChart).setOption(this.chart.dev);
            eCharts.init(this.$refs.broChart).setOption(this.chart.bro);
            eCharts.init(this.$refs.mapChart).setOption(this.chart.map);
            eCharts.init(this.$refs.torChart).setOption(this.chart.tor);
        },
        methods: {
            searchUrl() {
                console.log(111);
            },
            handleCurrentPage() {
                console.log(222);
            },
        },
    }
</script>

<style scoped>
    .ml-10{
        margin-left: 10px;
    }
    .app{
        height: auto;
        background-color: #f5f5f5;
    }
    .bra {
        width: 100%;
        height: 80px;
        background-color: #008DF2;
    }

    .mid{
        width: 1200px;
        height: auto;
        margin: 0 auto;
        padding-top: 20px;
    }
    .mid .ed-header{
        width: 100%;
        height: auto;
        background-color: #ffffff;
    }
    .ed-header .ed-filter{
        width: 100%;
        height: 80px;
        padding: 20px;
    }
    .ed-header .ed-link{
        width: 100%;
        height: 60px;
        padding: 20px;
        font-size: 14px;
    }
    .ed-header .ed-link .link1{
        display: inline-block;
        width: auto;
        height: 100%;
        color: #409eff;
        margin-right: 10px;
        vertical-align: top;
    }
    .ed-header .ed-link .link2{
        display: inline-block;
        max-width: 300px;
        height: 100%;
        color: #409eff;
        margin-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: top;
    }
    .footer{
        color: #666666;
        text-align: center;
        line-height: 114px;
    }
    .access-data{width: 1200px;height: 100px;margin-top: 30px;font-size: 0;}
    .access-data .ad-item{display: inline-block;width: 230px;height: 100px;vertical-align: top;background-color: #ffffff;position: relative;padding-left: 120px;}
    .access-data .ad-item.middle{margin: 0 75px;}
    .access-data .ad-item .l-icon{width: 100px;height: 100px;position: absolute;top: 0;left: 0;text-align: center;line-height: 100px;color: #ffffff;}
    .access-data .ad-item .l-icon i{font-size: 38px;}
    .access-data .ad-item .l-icon.bg-blue{background-color: #008df2;}
    .access-data .ad-item .l-icon.bg-green{background-color: #07cc00;}
    .access-data .ad-item .l-icon.bg-red{background-color: #ff4019;}
    .access-data .ad-item .m-data{width: 100%;height: 100%;}
    .access-data .ad-item .m-data .m-text{width: 100%;height: 40px;line-height: 50px;font-size: 14px;}
    .access-data .ad-item .m-data .m-num{width: 100%;height: 60px;line-height: 48px;font-size: 36px;}
    .chart-box1{width: 1160px;height: 440px;padding: 20px;font-size: 0;margin-top: 30px;background-color: #ffffff;}
    .chart-box2{width: 1160px;height: 740px;padding: 20px;font-size: 0;margin-top: 30px;background-color: #ffffff;}
    .chart-box1 .pie-chart{width: 580px;height: 440px;display: inline-block;vertical-align: top;}
    .chart-box1 .bar-chart{width: 580px;height: 440px;display: inline-block;vertical-align: top;}
    .chart-box1 .bar-chart .title{width: 100%;height: 30px;font-weight: bolder;font-size: 18px;color: #333333;}
    .chart-box1 .bar-chart .subtext{width: 100%;height: 20px;font-size: 12px;color: #aaaaaa;}
    .chart-box1 .bar-chart .progress{width: 100%;height: 390px;}
    .chart-box1 .bar-chart .progress .lab{width: 100%;height: 52px;line-height: 52px;font-size: 14px;}
    .record-box{width: 1160px;padding: 20px;margin-top: 30px;background-color: #ffffff;}
    .record-box .title{width: 100%;height: 30px;font-weight: bolder;font-size: 18px;color: #333333;}
    .record-box .subtext{width: 100%;height: 20px;font-size: 12px;color: #aaaaaa;}
    .record-box .content{width: 100%;height: auto;}
    .record-box .pagebar{width: 100%;height: 52px;margin-top: 20px;}
</style>
